/* ==========================================================================
   Binowee freight check
   Before checkout, the customer confirms a delivery postcode. The rules come
   from binowee-freight-zones.js (generated from stage3/freight-zones.yaml).

     Serviceable metro or CBD, cart at or under the threshold: on to checkout
       with the postcode carried across.
     Anything else (regional, Tasmania, NT, ACT, over the threshold): checkout
       is not offered. The cart lines move to the enquiry list and the enquiry
       modal opens, so the customer gets a freight quote instead of a dead end.

   The carrier rates endpoint in the Worker applies the same rules at checkout
   and returns no rate for these cases, so a customer who skips this step
   (accelerated checkout, JS off) still cannot be charged a wrong freight rate.
   All strings come from data attributes on #bw-freight (locale file).
   Placeholders in those strings are [price], [region], [threshold] and
   [postcode], not Liquid braces, so the t filter passes them through.
   ========================================================================== */
(function () {
  'use strict';

  var dlg = document.getElementById('bw-freight');
  var R = window.BinoweeFreightRules;
  if (!dlg || !R) return;

  var KEY = 'binowee.freight.postcode.v1';
  var form = dlg.querySelector('form');
  var input = dlg.querySelector('#bw-freight-postcode');
  var msg = dlg.querySelector('#bw-freight-msg');
  var go = dlg.querySelector('[data-bw-freight-checkout]');
  var enq = dlg.querySelector('[data-bw-freight-enquire]');
  var d = dlg.dataset;
  var lastFocus = null;
  var cart = null;

  function inRanges(pc, ranges) {
    for (var i = 0; i < ranges.length; i++) if (pc >= ranges[i][0] && pc <= ranges[i][1]) return true;
    return false;
  }
  /* Same behaviour as classify() in middleware/src/freight.js. */
  function classify(postcode, rules) {
    rules = rules || R;
    var s = String(postcode == null ? '' : postcode).trim();
    if (!/^\d{4}$/.test(s)) return { status: 'invalid' };
    var pc = parseInt(s, 10), k;
    for (k in rules.poa) if (inRanges(pc, rules.poa[k].ranges)) return { status: 'poa', area: k };
    for (k in rules.serviceable) {
      if (inRanges(pc, rules.serviceable[k].ranges)) return { status: rules.cbd.indexOf(pc) > -1 ? 'cbd' : 'metro', area: k };
    }
    for (var i = 0; i < rules.regions.length; i++) {
      if (inRanges(pc, rules.regions[i].ranges)) return { status: 'enquiry', region: rules.regions[i].name };
    }
    return { status: 'enquiry', region: null };
  }
  window.BinoweeFreight = { classify: classify };

  function money(n) {
    return '$' + n.toLocaleString('en-AU', Number.isInteger(n) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] == null ? '' : map[k]; }); }
  function save(pc) { try { window.sessionStorage.setItem(KEY, pc); } catch (e) {} }
  function saved() { try { return window.sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }

  function decide(pc) {
    var c = classify(pc);
    if (c.status === 'invalid') return { ok: false, text: d.errInvalid, invalid: true };
    var value = cart ? cart.total_price / 100 : 0;
    if (cart && cart.items.some(function (i) { return !(i.final_price > 0); })) return { ok: false, text: d.enquiryProduct };
    if (value > R.thresholdExGst) return { ok: false, text: fill(d.overThreshold, { threshold: money(R.thresholdExGst) }) };
    if (c.status === 'poa') return { ok: false, text: d.poa };
    if (c.status === 'enquiry') return { ok: false, text: c.region ? fill(d.region, { region: c.region }) : d.regional };
    var rate = R.rates[c.status];
    return { ok: true, text: fill(c.status === 'cbd' ? d.cbd : d.metro, { price: money(rate.incGst) }) };
  }

  function show(res) {
    msg.textContent = res.text || '';
    msg.hidden = !res.text;
    go.hidden = !res.ok;
    enq.hidden = res.ok || !!res.invalid;
  }

  function openDlg(trigger) {
    lastFocus = trigger || document.activeElement;
    go.hidden = true; enq.hidden = true; msg.hidden = true;
    input.value = saved();
    dlg.hidden = false;
    document.body.classList.add('bw-locked');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; if (input.value) show(decide(input.value)); })
      .catch(function () { cart = null; });
    input.focus();
  }
  function closeDlg() {
    dlg.hidden = true;
    document.body.classList.remove('bw-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Intercept every checkout control: cart page and cart drawer. Horizon uses
     name="checkout" on a submit button and /checkout links in places. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t || dlg.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    openDlg(t);
  }, true);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var pc = input.value.trim();
    var res = decide(pc);
    show(res);
    if (!res.invalid) save(pc);
    if (res.ok) go.focus();
  });
  input.addEventListener('input', function () { go.hidden = true; enq.hidden = true; });

  go.addEventListener('click', function () {
    var pc = input.value.trim();
    var res = decide(pc);
    if (!res.ok) { show(res); return; }
    window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
      'checkout?checkout[shipping_address][zip]=' + encodeURIComponent(pc) + '&checkout[shipping_address][country]=AU';
  });

  /* Move the cart lines to the enquiry list and hand over to the enquiry
     modal. The cart is left as it is, so nothing is lost if the customer
     comes back. */
  enq.addEventListener('click', function () {
    var E = window.BinoweeEnquiry;
    if (!E || !cart) { window.location.href = enq.dataset.fallback; return; }
    cart.items.forEach(function (i) {
      E.add({
        title: i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : ''),
        sku: i.sku || '', url: i.url || '', image: i.image || '', quantity: i.quantity
      });
    });
    E.setNote(fill(d.enquiryNote, { postcode: input.value.trim() }));
    closeDlg();
    E.open(enq);
  });

  dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-bw-freight-close]')) closeDlg(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dlg.hidden) closeDlg(); });
})();
